import React, {Component} from 'react';
import {Button, Modal, ModalBody, ModalFooter} from 'reactstrap';
import {markCancel, markSigned, saveSignature, show, showError} from '../../API/API';
import SignatureCanvas from "react-signature-canvas";
import Spinner from "react-spinkit";
import {Redirect} from "react-router-dom";
import './ReceiptSignature.css';
import Header from "../Header/Header";
import {logEvent, logPageView} from "../../AppHelpers/GoogleAnalytics";

class ReceiptSignature extends Component {
    signature = React.createRef()

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            width: 0
        };

        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        if (!this.props.location.state || !localStorage.getItem('token')) {
            return;
        }
        const {id, deviceName} = this.props.location.state;
        this.setState({id, deviceName, isLoading: true});
        show(id)
            .then(res => {
                setTimeout(() => {
                    this.cancel();
                }, 2 * 60 * 1000);
                if (res.data) {
                    this.setState({isLoading: false, receipt_html: res.data.data.receipt_html_unsigned})
                } else {
                    this.setState({isLoading: false, receipt_html: 'No Receipt.'})
                }
            })
            .catch((e) => {
                showError(e);
                this.setState({isLoading: false})
            })
    }

    cancel = () => {
        logEvent('User cancelled receipt', 'User');
        this.setState({isCancel: true});
        markCancel(this.state.id)
            .then(() => this.props.history.push("/slider", {deviceName: this.state.deviceName}))
            .catch((e) => {
                showError(e);
                this.setState({isLoading: false})
            })
    }

    toggle() {
        logEvent('User attempting to sign receipt', 'User');
        this.setState(prevState => ({
            modal: !prevState.modal
        }), () => this.getCanvasWidth());
    }

    saveSignature = () => {
        this.setState({isSaving: true});
        const signatureImage = this.signature.current.toDataURL();
        saveSignature(this.state.id, signatureImage)
            .then(res => {
                this.setState({
                    signatureImage,
                    isSaving: false,
                    receipt_html: res.data.data.receipt_html_signed,
                    modal: false
                })
            })
            .catch((e) => {
                showError(e);
                this.setState({isSaving: false})
            })
    }

    saveReceipt = () => {
        this.setState({isSaving: true});
        markSigned(this.state.id)
            .then(res => this.props.history.push("/feedback", this.state))
            .catch((e) => {
                showError(e);
                this.setState({isSaving: false})
            });
    }
    getCanvasWidth = () => {
        setTimeout(() => {
            const img = document.getElementById('modal');
            if (!img) return 0;
            const cs = getComputedStyle(img);
            const width = parseInt(cs.getPropertyValue('width'), 10) - 20;
            this.setState({width})

        }, 500)
    }

    render() {
        if (!this.props.location.state || !localStorage.getItem('token')) {
            return <Redirect to="/"/>
        }

        logPageView('/receipt');

        return (
            <div className="min-vh-100 d-flex flex-column">
                <Header/>
                <div className="container mt-2 d-flex justify-content-center align-items-center receipt">
                    {this.state.isLoading ?
                        <Spinner name="circle" fadeIn={0} color="#ccc" className="receipt-loading"/> :
                        <div style={{wordBreak: 'break-all', fontFamily: 'monospace'}}
                             dangerouslySetInnerHTML={{__html: this.state.receipt_html}}></div>}
                </div>
                <div className="actions">
                    <div className="row m-0 mb-1 mt-auto">
                        {this.state.signatureImage ?
                            <React.Fragment>
                                <div className="col-lg-4 col-12 mt-2 pr-0 pl-0 col-md-4 col-sm-4">
                                    <button className="btn button btn-info w-100 p-2 mt-auto mt-4"
                                            onClick={this.toggle}>
                                        <div className="round-circle bg-primary-dark">
                                            <i className="fa fa-check"></i>
                                        </div>
                                        <div className="mr-auto ml-auto">Re-Sign Receipt</div>
                                    </button>
                                </div>
                                <div className="col-lg-4 col-12 mt-2 pr-0 pl-0 col-md-4 col-sm-4">
                                    <button className="btn bg-light button w-100 p-2 mt-auto" onClick={this.cancel}>
                                        <div className="round-circle bg-cancel">
                                            <i className="fa fa-times text-white" aria-hidden="true"></i>
                                        </div>
                                        <div className="mr-auto ml-auto">
                                            {
                                                this.state.isCancel ?
                                                    <Spinner name="circle" fadeIn={0} color="#fff"/> :
                                                    'Cancel'
                                            }
                                        </div>
                                    </button>
                                </div>
                                <div className="col-lg-4 col-12 mt-2 pr-0 pl-0 col-md-4 col-sm-4">
                                    <button className="btn button btn-info  w-100 p-2 mt-auto mt-4"
                                            onClick={this.saveReceipt}>
                                        <div className="round-circle bg-primary-dark">
                                            <i className="fa fa-check"></i>
                                        </div>
                                        <div className="mr-auto ml-auto">
                                            {
                                                this.state.isSaving ?
                                                    <Spinner name="circle" fadeIn={0} color="#fff"/> :
                                                    'Save'
                                            }
                                        </div>
                                    </button>
                                </div>
                            </React.Fragment> :
                            <React.Fragment>
                                <div className="col-lg-6 col-md-6 col-sm-6  col-12 mt-2 pl-0 pr-0">
                                    <button className="btn bg-light button w-100 p-2 mt-auto mt-4"
                                            onClick={this.cancel}>
                                        <div className="round-circle bg-cancel">
                                            <i className="fa fa-times text-white"></i>
                                        </div>
                                        <div className="mr-auto ml-auto">
                                            {
                                                this.state.isCancel ?
                                                    <Spinner name="circle" fadeIn={0} color="#fff"/> :
                                                    'Cancel'
                                            }
                                        </div>
                                    </button>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-12 mt-2 pl-0 pr-0">
                                    <button className="btn button btn-info  w-100 p-2 ml-0 mr-0"
                                            disabled={this.state.isLoading} onClick={this.toggle}>
                                        <div className="round-circle bg-primary-dark">
                                            <i className="fa fa-check"></i>
                                        </div>
                                        <div className="mr-auto ml-auto"> Sign Receipt</div>
                                    </button>
                                </div>
                            </React.Fragment>
                        }
                    </div>
                </div>
                <div>
                    <Modal size="xl" isOpen={this.state.modal} toggle={this.toggle}>
                        <ModalBody id="modal"
                                   className="modal-height d-flex justify-content-center modal-1 signature-canvas-modal">
                            <SignatureCanvas penColor='black'
                                             ref={this.signature}
                                             minDistance={0}
                                             onEnd={() => this.setState({valid: true})}
                                             canvasProps={{
                                                 className: 'bg-white signature-canvas modal-xl'
                                             }}/>
                        </ModalBody>
                        <ModalFooter className="justify-content-between">
                            <Button style={{backgroundColor: 'rgba(207, 207, 207, 1)', color: "black"}}
                                    onClick={() => this.toggle()}>Close</Button>{' '}
                            <Button style={{backgroundColor: 'rgba(207, 207, 207, 1)', color: "black"}}
                                    onClick={() => this.signature.current.clear()}>Clear</Button>{' '}
                            <Button style={{backgroundColor: 'rgba(207, 207, 207, 1)', color: "black"}}
                                    disabled={!this.state.valid}
                                    onClick={this.saveSignature}>
                                {
                                    this.state.isSaving ?
                                        <Spinner name="circle" fadeIn={0} color="#000"/> :
                                        'Save'
                                }
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            </div>
        )
    }
}

export default ReceiptSignature;
